<template>
    <div v-loading="loading">
        <div v-show="!editInfo" class="header">
            <div>
                <p style="display: inline-block;padding-right: 50px"
                   v-text="`渠道名称：${info.name}(ID：${info.id})`"></p>
                默认通道：
                <el-switch
                        :value="detail.isDefault"
                        @change="defaultChange"
                        :active-value="true"
                        :inactive-value="false"/>
            </div>
            <el-button
                    size="small"
                    type="primary"
                    @click="addPaymentFunc">新增
            </el-button>
        </div>
        <div v-show="!editInfo" class="common-table" style="margin-top: 0">
            <el-table
                    :data="detail.paymentInfos"
                    row-key="id"
                    height="390px">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column label="名称" align="center" prop="name"/>
                <el-table-column label="是否使用" align="center">
                    <template slot-scope="scope">{{scope.row.status?'是':'否'}}</template>
                </el-table-column>
                <el-table-column align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" size="mini" @click="editInfo = scope.row">编辑</el-button>
                        <el-button type="danger" size="mini" @click="deleteFunc(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <comp-withdrawal-config
                v-if="editInfo"
                :info="info"
                :form="editInfo"
                @my-close="getDetail()"/>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'
    import compWithdrawalConfig from './compWithdrawalConfig'

    export default {
        props: {
            info: Object,
            paymentCode: String
        },
        components: {
            compWithdrawalConfig
        },
        data() {
            return {
                loading: false,
                detail: {
                    isDefault: false,
                    paymentInfos: []
                },
                editInfo: null,// 编辑的信息
            }
        },
        created() {
            this.getDetail()
        },
        methods: {
            ...mapActions('payChannel', ['getChannelPaymentQuery', 'setSDKDefault', 'deleteSDK']),
            getDetail() {
                this.editInfo = null;
                this.loading = true;
                this.getChannelPaymentQuery({
                    id: this.info.id,
                    paymentCode: this.paymentCode,
                    type: 1
                }).then(res => {
                    this.detail = res.data;
                    this.loading = false;
                })
            },
            defaultChange() {
                this.setSDKDefault({
                    id: this.info.id,
                    paymentCode: this.paymentCode,
                    type: 1
                }).then(() => {
                    this.$message.success('修改成功');
                    this.getDetail()
                })
            },
            addPaymentFunc() {
                this.editInfo = {
                    businessKey: '',
                    businessNum: '',
                    code: this.paymentCode,
                    contactAccount: '',
                    id: '',
                    name: '',
                    paymentMode: '',
                    publicKey: '',
                    status: '',
                }
            },
            deleteFunc(row) {
                this.$confirm(`是否确认删除${row.code}配置${row.name}？`, '温馨提示', {
                    type: 'info'
                }).then(() => {
                    this.deleteSDK({
                        id: row.id
                    }).then(() => {
                        this.$message.success('删除成功');
                        this.getDetail()
                    })
                }).catch(() => {
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .header {
        display: flex;
        justify-content: space-between;
        padding-left: 5px;
    }

    .form {
        width: 500px;
        padding-right: 30px;
        margin: 35px auto 0;
    }
</style>